import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@material-ui/core';
import React from 'react';
import { Formik, Form } from 'formik';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

const SendEmailModal = ({ userId, emails, showModal, MODAL_TYPE }) => {
    const { notifyError, notifySuccess } = useNotify();

    const validateForm = values => {
        const errors = {};
        if (!values.subject) {
            errors.subject = 'Subject is required!';
        }
        if (!values.message) {
            errors.message = 'Message is required!';
        }
        return errors;
    };

    const handleSubmit = async values => {
        try {
            await doSwaggerCall('users', 'sendCustomEmail', {
                userId,
                emailData: {
                    subject: values.subject,
                    message: values.message
                }
            });
            notifySuccess('Email sent successfully');
            showModal(MODAL_TYPE.NONE);
        } catch (error) {
            let errorMessage = 'Failed to send email';
            if (error.response.data && typeof error.response.data === 'string') {
                const parsedError = JSON.parse(error.response.data);
                notifyError(parsedError.message || errorMessage);
            } else {
                notifyError(errorMessage);
            }
        }
    };

    return (
        <Dialog
            aria-labelledby="email-modal"
            open
            maxWidth="sm"
            fullWidth
            onClose={() => showModal(MODAL_TYPE.NONE)}
        >
            <DialogTitle>Send Email</DialogTitle>
            <Formik
                initialValues={{ message: '', subject: '' }}
                onSubmit={handleSubmit}
                validate={validateForm}
            >
                {({ values, errors, handleChange, isSubmitting }) => (
                    <Form>
                        <DialogContent>
                            {emails && emails.length > 0 && (
                                <TextField
                                    label="To"
                                    value={emails.join(', ')}
                                    fullWidth
                                    variant="outlined"
                                    style={{ margin: '16px 0' }}
                                    disabled
                                />
                            )}
                            <TextField
                                label="Subject"
                                name="subject"
                                value={values.subject}
                                onChange={handleChange}
                                fullWidth
                                variant="outlined"
                                style={{ margin: '16px 0' }}
                                InputProps={{ required: true }}
                                error={!!errors.subject}
                                helperText={!!errors.subject ? 'Subject is required!' : ''}
                            />
                            <TextField
                                label="Message"
                                name="message"
                                value={values.message}
                                onChange={handleChange}
                                multiline
                                minRows={6}
                                fullWidth
                                variant="outlined"
                                InputProps={{
                                    required: true
                                }}
                                error={!!errors.message}
                                helperText={!!errors.message ? 'Message is required!' : ''}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                                Close
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                disabled={Object.keys(errors).length > 0 || isSubmitting}
                                type="submit"
                            >
                                Send Email
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
};

export default SendEmailModal;
